export const sortArrayByKeyProp = (array, key) => array.sort((a, b) => a[key] - b[key])
